import React from 'react';

import Label from '../../../components/plain/Label';
import FieldString from '../../../components/plain/FieldString';
import FieldEnum from '../../../components/plain/FieldEnum';
import FieldReference from '../../../components/plain/FieldReference';
import FieldFile from '../../../components/plain/FieldFile';
import FieldList_CardsPanel from '../../../components/plain/FieldList_CardsPanel';
import FieldList_Strings from '../../../components/plain/FieldList_Strings';

import { CLASS_BOOK, CLASS_WORK } from '../../../util/consts/classes';
import { BOOK_PLAIN_PATH, WORK_PLAIN_PATH } from '../../../util/routes';
import { FORM_BOOK_TABLE, FORM_WORK_TABLE } from '../../../util/consts/forms';

class DivDerivativePanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}

	derivativeInfoCardBuilder = (fieldDerivativeInfo, index) => {
		let card = '';

		if( fieldDerivativeInfo.value.name.value )
			card += fieldDerivativeInfo.value.name.value;
			
		if( card.length > 40 )
			card = card.substring(0, 37) + '...'
			
		return card;
	}
	fileCardBuilder = (fieldFile, index) => {
		let card = '';

		if( fieldFile.value.resourceName.value )
			card += fieldFile.value.resourceName.value;
			
		if( card.length > 40 )
			card = card.substring(0, 37) + '...'
			
		return card;
	}
	
	render() {
		let readOnly = this.props.readOnly;
		let fieldGroup = this.props.fieldGroup;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let workRefHtml = null;
		if( this.props.isPlain ) {
			workRefHtml = (
				<FieldReference instance={instance} path={'workRef'} parentField={fieldGroup} plain={plain} 
					readOnly={readOnly}
					styles={{ divMain: {marginLeft: '20px', flexGrow: '1'} }}
					refNodes={[
						{
							classId: CLASS_BOOK, plainFormPath: BOOK_PLAIN_PATH, 
							selectInstanceFormId: FORM_BOOK_TABLE,
							selectInstanceFormTitle: 'Книги'
						},
						{
							classId: CLASS_WORK, plainFormPath: WORK_PLAIN_PATH, 
							selectInstanceFormId: FORM_WORK_TABLE,
							selectInstanceFormTitle: 'Твори'
						}
					]}
				/>
			)
		}
		let bodyHtml = (
			<React.Fragment>
				<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
					<FieldEnum instance={instance} path={'type'} parentField={fieldGroup} plain={plain} 
						readOnly={readOnly}
					/>
					{workRefHtml}
				</div>
				<FieldList_CardsPanel path={'/derivativeInfo'} instance={instance} parentField={fieldGroup} plain={plain}
					labelEmptyToHeader={true}
					itemComponent={DerivativeInfoPanel} itemCardBuilder={this.derivativeInfoCardBuilder}
					readOnly={readOnly}
					styles={{
						divMainStyle: {
							marginTop: '10px',
							padding: '10px 10px 10px 10px',
							backgroundColor: 'rgb(200,200,200)',
							border: '1px solid blue'
						},
						divCardsBlock: {
							marginRight: '10px',
							minWidth: '300px',
							maxWidth: '300px',
							backgroundColor: 'rgb(200,200,200)',
						},
						divCard: {
							marginTop: '3px',
							padding: '7px',
							cursor: 'pointer',
							backgroundColor: 'rgb(230,230,230)',
							minHeight: '18px'
							
						}
					}}
				/>
				<FieldList_Strings instance={instance} path={'resourceLink'} parentField={fieldGroup} plain={plain} 
					readOnly={readOnly} 
					styles={{divMain: {marginTop: '10px'} }}
				/>
				<FieldList_CardsPanel path={'/images'} instance={instance} parentField={fieldGroup} plain={plain}
					labelEmptyToHeader={true} 
					itemComponent={FilePanel} itemCardBuilder={this.fileCardBuilder}
					readOnly={readOnly}
					styles={{
						divMainStyle: {
							marginTop: '10px',
							padding: '10px 10px 10px 10px',
							backgroundColor: 'rgb(200,200,200)',
							border: '1px solid blue'
						},
						divCardsBlock: {
							marginRight: '10px',
							minWidth: '200px',
							backgroundColor: 'rgb(200,200,200)',
						},
						divCard: {
							marginTop: '3px',
							padding: '7px',
							cursor: 'pointer',
							backgroundColor: 'rgb(230,230,230)',
							minHeight: '18px'
							
						}
					}}
				/>
			</React.Fragment>
		)
		if( this.props.isPlain ) {
			return <div>{bodyHtml}</div>;
		}
		return (
			<div style={{flexGrow: '1', backgroundColor: 'rgb(220,220,220)'}}>
				<div style={{margin: '10px', padding: '10px', border: '1px solid gray'}}>
					{bodyHtml}
				</div>
			</div>
		)
	}
}

class DerivativeInfoPanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}
	
	render() {
		let readOnly = this.props.readOnly;
		let fieldGroup = this.props.fieldGroup;
		let plain = this.props.plain;
		let instance = this.props.instance;
		return (
			<div style={{flexGrow: '1', margin: '0 0 0 15px', padding: '10px', backgroundColor: 'rgb(240,240,240)'}}>
				<div style={{margin: '10px', padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldEnum instance={instance} path={'language'} parentField={fieldGroup} plain={plain}
							styleSelect={{flexGrow: '1'}}
							readOnly={readOnly}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'name'} parentField={fieldGroup} plain={plain}
							styleInput={{flexGrow: '1'}}
							readOnly={readOnly}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'description'} parentField={fieldGroup} plain={plain}
							styleInput={{flexGrow: '1'}}
							readOnly={readOnly}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'comment'} parentField={fieldGroup} plain={plain}
							styleInput={{flexGrow: '1'}}
							readOnly={readOnly}
						 />
					</div>
				</div>
			</div>
		)
	}
}

class FilePanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}
	
	render() {
		let readOnly = this.props.readOnly;
		var fieldGroup = this.props.fieldGroup;
		var plain = this.props.plain;
		var instance = this.props.instance;
		return (
			<div style={{flexGrow: '1', margin: '0 0 0 15px', padding: '10px', backgroundColor: 'rgb(240,240,240)'}}>
				<div style={{margin: '10px', padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'resourceName'} parentField={fieldGroup} plain={plain}
							styleInput={{flexGrow: '1'}}
							readOnly={readOnly}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<Label title={'Файл'} style={{marginRight: '10px'}}/>
						<FieldFile instance={instance} path={'resourceFile'} parentField={fieldGroup} plain={plain}
							styleDiv={{flexGrow: '1'}}
							readOnly={readOnly}
						 />
					</div>
				</div>
			</div>
		)
	}
}

export default DivDerivativePanel;